module.exports = __webpack_public_path__ + "static/media/biofinity.df483a0c.jpg";